// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvertisingBenefits_wrapper__63FGp"};